
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $T1bCI = parcelRequire("T1bCI");


var $3tMMZ = parcelRequire("3tMMZ");


var $gz8ZY = parcelRequire("gz8ZY");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $hDG7z = parcelRequire("hDG7z");

/**
 * @graphql cc
 */ 









var $jSnXV = parcelRequire("jSnXV");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $4VJDS = parcelRequire("4VJDS");


var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $42omo.useRef)(null);
    const allAppsLoaded = (0, $42omo.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const presetTimeoutConfig = (0, $4VJDS.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $4VJDS.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id theme{themeKey}}}`, {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        }
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch && (0, $6mKj3.expVal)('confluence_remove_atlgeneral_height_timeout', 'isEnabled', false)) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch && (0, $6mKj3.expVal)('confluence_remove_atlgeneral_height_timeout', 'isEnabled', false)) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");



























var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $42omo.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
            if (entry) {
                document.documentElement.style.setProperty('--forge-page-banner-height', `${entry.target.clientHeight}px`);
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: entry.target.clientHeight
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};






var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $1DWH0 = parcelRequire("1DWH0");


var $9wGTI = parcelRequire("9wGTI");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $1DWH0.default)()(class ReturnToMobileComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1yt4pxbi _11q7i8nm _y3gn1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__enterprise-exp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            href: "#",
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", ()=>{
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $42omo.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");








var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");





var $jmjWc = parcelRequire("jmjWc");


const $727a4bb7ae4ee699$export$1584143957275f3b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qS8Rk",
    name: "FloatingNoteLayout",
    loader: async ()=>(await (parcelRequire("epTVL"))).FloatingNoteLayout
});





var $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db;
$ae6f1a0e4a2e28fc$export$da31f8cf16ec20db = `OsGcuW_dialogStyle`;









function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
};


const $4e0d0b830c02a893$export$7292bf0b169ba997 = new (0, $3e6Uc.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_1e0c1ule",
    hidePanel: "_1e0cglyw"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_v5641fl4 _2lx2vrvc _1n261g80 _1bsb15jn _18u0v77o _1s6jaq80",
    enableRightSidebar: "_1bsbsul6",
    nav4Enabled: "_1bsb1osq _18u0ze3t",
    addMinWidth: "_1ul9cv93"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_1e0cglyw _1pby1ial _1bsb1osq _kqsw1n9t _bfhkvuon _1ltv1d4h _p12f18ua",
    showPanel: "_1e0c1ule",
    isFullWidth: "_1ltvidpf _p12fglyw"
};
const $4e0d0b830c02a893$var$floatingNoteFixedWrapperStyles = {
    default: "_1pby9y44 _kqsw1n9t _1bsbsul6 _4t3i1osq _lcxvglyw"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7vuon _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles
const $4e0d0b830c02a893$var$ContentBodyWithContainerType = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7vuon _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq _7cca15wb _1f381gzp",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$export$80006b81bf20e108 = ({ enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isPdfExport = typeof window !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, isFullWidth: isFullWidth, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, isForgePageBannerFullWidth: isForgePageBannerFullWidth, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, isNav4Enabled, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    (0, $42omo.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isNav4Enabled && isFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1wzo"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isNav4Enabled && isForgePageBannerFullWidth && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['isFullWidth']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3irbkl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null));
    const layoutInner = children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /*
        * Previously, this used to be a `<Global styles={[…]} />` from Emotion, GlobalImagePreviewStyling
        * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
        */ // TODO: remove this when confluence-previews no longer used
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            isNav4Enabled && !(0, $9wGTI.fg)('confluence_nav4_layout_bug_fixes_1') && $4e0d0b830c02a893$var$mainContentContainerStyles['nav4Enabled'],
            enableRightSidebarCSS && $4e0d0b830c02a893$var$mainContentContainerStyles['enableRightSidebar'],
            isNav4Enabled && (0, $9wGTI.fg)('confluence_nav4_layout_bug_fixes_1') && $4e0d0b830c02a893$var$mainContentContainerStyles['nav4Enabled'],
            $ae6f1a0e4a2e28fc$export$da31f8cf16ec20db
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, (0, $6mKj3.expVal)('cc_notes', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "main-layout-notes-fixed-container",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$floatingNoteFixedWrapperStyles.default
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $727a4bb7ae4ee699$export$1584143957275f3b), null)), shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_16jlidpf _1o9zkb7n _i0dl1wug _19pkidpf _vchhusvi _11rm1hrf _kqswh2mm _1bsb1osq _1e0c1txw _1tken7od"
            ])
        }, (0, $9wGTI.fg)('confluence_frontend_content_body_container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$var$ContentBodyWithContainerType, {
            "data-test-id": "content-body",
            "data-vc": "content-body-with-container-type-compiled",
            id: "content-body",
            style: topElementStyle
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle
        }, children))), !isEdit && !isLivePage && !ommitComponentsNotNeededForPdfExport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)))) : null;
    return layoutInner;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $42omo.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $42omo.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hDG7z.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: $4e0d0b830c02a893$export$7292bf0b169ba997
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content));
    return content;
};


const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $42omo.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode}}}}}`, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_recentDropdown"] = $35b50a968705ed01$export$1a3cc5086fadf289;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("hDG7z", function(module, exports) {
//this file switches between Nav 3 and Nav 4 page-layout components. When Nav 4 is at 100% this file can simply be deleted and index can export nav 4 directly instead

var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $cgEsw = parcelRequire("cgEsw");


var $jbuqY = parcelRequire("jbuqY");

const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
};
module.exports["PageLayout"] = $c8aadc7c03a52230$export$6d1402fb58384e4f;

});

parcelRegister("cgEsw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf3be568142fa4d$export$25b68ac96f2af713 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y6119",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("gfJXD"))).PageLayout
});
module.exports["Nav4Layout"] = $acf3be568142fa4d$export$25b68ac96f2af713;

});

parcelRegister("gfJXD", function(module, exports) {

let $bd51b2f27cdc12a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bd51b2f27cdc12a2$var$load("7Omhy"),
    $bd51b2f27cdc12a2$var$load("1QdXB"),
    $bd51b2f27cdc12a2$var$load("aF1BH"),
    $bd51b2f27cdc12a2$var$load("6sGtZ"),
    $bd51b2f27cdc12a2$var$load("5IgYU"),
    $bd51b2f27cdc12a2$var$load("8bVS2"),
    $bd51b2f27cdc12a2$var$load("6EQss"),
    $bd51b2f27cdc12a2$var$load("bnzpb"),
    $bd51b2f27cdc12a2$var$load("8JZKd"),
    $bd51b2f27cdc12a2$var$load("6FuHS"),
    $bd51b2f27cdc12a2$var$load("eyaRC"),
    $bd51b2f27cdc12a2$var$load("7WaUI"),
    $bd51b2f27cdc12a2$var$load("3Kg3S"),
    $bd51b2f27cdc12a2$var$load("hG1nn"),
    $bd51b2f27cdc12a2$var$load("jTXJu"),
    $bd51b2f27cdc12a2$var$load("dKKX2"),
    $bd51b2f27cdc12a2$var$load("9GMEV"),
    $bd51b2f27cdc12a2$var$load("fgH74"),
    $bd51b2f27cdc12a2$var$load("lddtD"),
    $bd51b2f27cdc12a2$var$load("1aPQ5"),
    $bd51b2f27cdc12a2$var$load("4YwES"),
    $bd51b2f27cdc12a2$var$load("g2QSG"),
    $bd51b2f27cdc12a2$var$load("9mtZC"),
    $bd51b2f27cdc12a2$var$load("6tsCm"),
    $bd51b2f27cdc12a2$var$load("lWxi6"),
    $bd51b2f27cdc12a2$var$load("gMWRW"),
    $bd51b2f27cdc12a2$var$load("2tSa5"),
    $bd51b2f27cdc12a2$var$load("jvHRs"),
    $bd51b2f27cdc12a2$var$load("gLGsg"),
    $bd51b2f27cdc12a2$var$load("dChec"),
    $bd51b2f27cdc12a2$var$load("9XYQ9"),
    $bd51b2f27cdc12a2$var$load("aeEUI"),
    $bd51b2f27cdc12a2$var$load("iXzmH"),
    $bd51b2f27cdc12a2$var$load("65c4i"),
    $bd51b2f27cdc12a2$var$load("6wr18"),
    $bd51b2f27cdc12a2$var$load("kjZZD"),
    $bd51b2f27cdc12a2$var$load("1qlDN"),
    $bd51b2f27cdc12a2$var$load("1yVM6"),
    $bd51b2f27cdc12a2$var$load("awqCy"),
    $bd51b2f27cdc12a2$var$load("fZt2F"),
    $bd51b2f27cdc12a2$var$load("4shpn"),
    $bd51b2f27cdc12a2$var$load("cIHDc"),
    $bd51b2f27cdc12a2$var$load("6vEb6"),
    $bd51b2f27cdc12a2$var$load("Wowvf"),
    $bd51b2f27cdc12a2$var$load("dS0Pr"),
    $bd51b2f27cdc12a2$var$load("huYla"),
    $bd51b2f27cdc12a2$var$load("amUNi"),
    $bd51b2f27cdc12a2$var$load("8Gekp"),
    $bd51b2f27cdc12a2$var$load("37ZO9"),
    $bd51b2f27cdc12a2$var$load("1GxVg"),
    $bd51b2f27cdc12a2$var$load("lTA9n"),
    $bd51b2f27cdc12a2$var$load("ffEVr"),
    $bd51b2f27cdc12a2$var$load("kUbUu"),
    $bd51b2f27cdc12a2$var$load("hhss7"),
    $bd51b2f27cdc12a2$var$load("7EorR"),
    $bd51b2f27cdc12a2$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("jbuqY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6f90fb0ae36f35f$export$7faac1b59c375dfa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oUMKP",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("c9VIr"))).PageLayout
});
module.exports["Nav3Layout"] = $f6f90fb0ae36f35f$export$7faac1b59c375dfa;

});

parcelRegister("c9VIr", function(module, exports) {

let $8da31876f5f7935d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8da31876f5f7935d$var$load("gMWRW"),
    $8da31876f5f7935d$var$load("lTA9n"),
    $8da31876f5f7935d$var$load("6wr18"),
    $8da31876f5f7935d$var$load("6tsCm"),
    $8da31876f5f7935d$var$load("2F69B"),
    $8da31876f5f7935d$var$load("fZt2F"),
    $8da31876f5f7935d$var$load("ffEVr"),
    $8da31876f5f7935d$var$load("dS0Pr"),
    $8da31876f5f7935d$var$load("huYla"),
    $8da31876f5f7935d$var$load("amUNi"),
    $8da31876f5f7935d$var$load("37ZO9"),
    $8da31876f5f7935d$var$load("1GxVg"),
    $8da31876f5f7935d$var$load("hhss7"),
    $8da31876f5f7935d$var$load("7Omhy"),
    $8da31876f5f7935d$var$load("kC80R"),
    $8da31876f5f7935d$var$load("7EorR"),
    $8da31876f5f7935d$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("9Z1sw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $gTyTP = parcelRequire("gTyTP");


var $iqPSe = parcelRequire("iqPSe");


var $8pvtc = parcelRequire("8pvtc");

const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = ({ children: children, locationName: locationName, panels: panels })=>{
    if (!(0, $9wGTI.fg)('confluence_annotate_3p_web_panel')) return children;
    // If all panels are empty, exclude it from UFOThirdPartySegment
    const panelHasContent = panels?.length && panels.some((panel)=>panel.html !== '');
    if (!panelHasContent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: `web-panel-${locationName}`
    }, children);
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $42omo.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $8pvtc.WebPanelLocationQuery),
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    }, ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        if (isLivePagesFeatureEnabled) panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    }));
};
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $42omo = parcelRequire("42omo");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3({ html: html, panelId: panelId }) {
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    const moduleLocationMatch = html.match(/"moduleLocation"\s*:\s*"atl\.general"/);
    // Restrict to just atl-general for now
    const isAtlGeneralWebpanel = Boolean(moduleLocationMatch);
    (0, $42omo.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (isAtlGeneralWebpanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
            if (window?.__HYDRATABLE__) {
                const scriptElement = container.querySelector('script.ap-iframe-body-script');
                if (scriptElement) {
                    const scriptContent = scriptElement.textContent || '';
                    const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                    if (match) {
                        const uniqueKey = match[1];
                        // Find iframe whose id contains the uniqueKey
                        const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                        if (iframe) return;
                    }
                }
            }
            if (ssrSuccess) setSsrSuccess(false);
        }
        (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
    }, [
        html,
        panelId,
        ssrSuccess,
        isAtlGeneralWebpanel
    ]);
    return isAtlGeneralWebpanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
        id: panelId ?? 'WebPanel',
        triggers: [
            {
                type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
            }
        ],
        ssrSuccess: ssrSuccess,
        analyticsName: "WebPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc-ignore-if-no-layout-shift": true,
        dangerouslySetInnerHTML: {
            __html: html
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        "data-vc-ignore-if-no-layout-shift": true,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("6UM2Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

function $68e0b10beef6f399$export$1db2f2faaee8467f({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $42omo.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const renderChildren = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $42omo.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
}
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("jln20", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>(0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = ({ children: children })=>{
    const [sidebars, setSidebars] = (0, $42omo.useState)([]);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    const contextValue = (0, $42omo.useMemo)(()=>$8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        }), [
        sidebars,
        triggerButtonRef,
        hideObjectSidebar,
        hidePreviewPanel,
        isPreviewPanelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleCloseGlobalSidebar = ()=>{
            setSidebars([]);
        };
        // Register the global window event when the component mounts
        window.addEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        return ()=>{
            // Unregister the global window event when the component unmounts
            window.removeEventListener('closeGlobalSidebar', handleCloseGlobalSidebar);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
        value: contextValue
    }, children);
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("6yagU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fN3iy = parcelRequire("fN3iy");


var $dj7jL = parcelRequire("dj7jL");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $42omo.useCallback)(()=>{
        /*
		Any time a Preview Panel is opened in Confluence, we want to close all
		non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
		*/ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $42omo.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
			Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
			next panel are different, we want to close the previous panel before opening the new one. In order to
			do this we need to pass the preview panel api
		*/ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN3iy.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $QU6QS.useLocation)();
    const previousLocation = (0, $42omo.useRef)(location);
    (0, $42omo.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $4BDAe = parcelRequire("4BDAe");

var $fN3iy = parcelRequire("fN3iy");


var $9wGTI = parcelRequire("9wGTI");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("8zMP3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $eS4vC = parcelRequire("eS4vC");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $42omo.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = ()=>{
    return (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $42omo.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $42omo.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("epTVL", function(module, exports) {

let $a7eec9259085e504$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a7eec9259085e504$var$load("6wr18"),
    $a7eec9259085e504$var$load("kFrh6"),
    $a7eec9259085e504$var$load("7WcBh"),
    $a7eec9259085e504$var$load("7Muyv"),
    $a7eec9259085e504$var$load("gM7lZ"),
    $a7eec9259085e504$var$load("3xuDK"),
    $a7eec9259085e504$var$load("2Mq3f"),
    $a7eec9259085e504$var$load("4drdS"),
    $a7eec9259085e504$var$load("g5HUX"),
    $a7eec9259085e504$var$load("9A0ig"),
    $a7eec9259085e504$var$load("gLGsg"),
    $a7eec9259085e504$var$load("ffEVr"),
    $a7eec9259085e504$var$load("fDmB2")
]).then(()=>parcelRequire('4GYnQ'));

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("gpI6X"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("5cWfg"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("fPofH"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("dxq9B"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("9ntg5"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("01OTD"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("f4Yec"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("1qLQm"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("hiGFp"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6gEsG"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("jP195"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("2K4NM"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("gpI6X", function(module, exports) {

let $bf3132b98c32b1cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf3132b98c32b1cc$var$load("2YffH"),
    $bf3132b98c32b1cc$var$load("8Kivm"),
    $bf3132b98c32b1cc$var$load("cf5vC"),
    $bf3132b98c32b1cc$var$load("9njyL"),
    $bf3132b98c32b1cc$var$load("esA9a"),
    $bf3132b98c32b1cc$var$load("iQ0Jm"),
    $bf3132b98c32b1cc$var$load("coJiW"),
    $bf3132b98c32b1cc$var$load("8TKWI"),
    $bf3132b98c32b1cc$var$load("RXppq"),
    $bf3132b98c32b1cc$var$load("h4Nf7"),
    $bf3132b98c32b1cc$var$load("7f9Fz"),
    $bf3132b98c32b1cc$var$load("8YSo7"),
    $bf3132b98c32b1cc$var$load("fqGSw"),
    $bf3132b98c32b1cc$var$load("2spqH"),
    $bf3132b98c32b1cc$var$load("gWSdF"),
    $bf3132b98c32b1cc$var$load("6FuHS"),
    $bf3132b98c32b1cc$var$load("eyaRC"),
    $bf3132b98c32b1cc$var$load("g9CVe"),
    $bf3132b98c32b1cc$var$load("aeEUI"),
    $bf3132b98c32b1cc$var$load("iXzmH"),
    $bf3132b98c32b1cc$var$load("65c4i"),
    $bf3132b98c32b1cc$var$load("6wr18"),
    $bf3132b98c32b1cc$var$load("kjZZD"),
    $bf3132b98c32b1cc$var$load("3TTZL"),
    $bf3132b98c32b1cc$var$load("37ldp"),
    $bf3132b98c32b1cc$var$load("awqCy"),
    $bf3132b98c32b1cc$var$load("kHOMt"),
    $bf3132b98c32b1cc$var$load("hhss7"),
    $bf3132b98c32b1cc$var$load("e4USi"),
    $bf3132b98c32b1cc$var$load("fqika"),
    $bf3132b98c32b1cc$var$load("dlZSj"),
    $bf3132b98c32b1cc$var$load("Wowvf"),
    $bf3132b98c32b1cc$var$load("dS0Pr"),
    $bf3132b98c32b1cc$var$load("huYla"),
    $bf3132b98c32b1cc$var$load("8bVS2"),
    $bf3132b98c32b1cc$var$load("37ZO9"),
    $bf3132b98c32b1cc$var$load("1GxVg"),
    $bf3132b98c32b1cc$var$load("lTA9n"),
    $bf3132b98c32b1cc$var$load("6EQss"),
    $bf3132b98c32b1cc$var$load("6M36W"),
    $bf3132b98c32b1cc$var$load("ffEVr"),
    $bf3132b98c32b1cc$var$load("kUbUu"),
    $bf3132b98c32b1cc$var$load("9ftJe"),
    $bf3132b98c32b1cc$var$load("hUIij"),
    $bf3132b98c32b1cc$var$load("6Up0b"),
    $bf3132b98c32b1cc$var$load("lnKog"),
    $bf3132b98c32b1cc$var$load("7Omhy"),
    $bf3132b98c32b1cc$var$load("kC80R"),
    $bf3132b98c32b1cc$var$load("7EorR"),
    $bf3132b98c32b1cc$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("5cWfg", function(module, exports) {

let $3cab4107c0c47fc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3cab4107c0c47fc8$var$load("2YffH"),
    $3cab4107c0c47fc8$var$load("8Kivm"),
    $3cab4107c0c47fc8$var$load("cf5vC"),
    $3cab4107c0c47fc8$var$load("9njyL"),
    $3cab4107c0c47fc8$var$load("esA9a"),
    $3cab4107c0c47fc8$var$load("iQ0Jm"),
    $3cab4107c0c47fc8$var$load("coJiW"),
    $3cab4107c0c47fc8$var$load("8TKWI"),
    $3cab4107c0c47fc8$var$load("RXppq"),
    $3cab4107c0c47fc8$var$load("h4Nf7"),
    $3cab4107c0c47fc8$var$load("7f9Fz"),
    $3cab4107c0c47fc8$var$load("8YSo7"),
    $3cab4107c0c47fc8$var$load("fqGSw"),
    $3cab4107c0c47fc8$var$load("2spqH"),
    $3cab4107c0c47fc8$var$load("gWSdF"),
    $3cab4107c0c47fc8$var$load("6FuHS"),
    $3cab4107c0c47fc8$var$load("eyaRC"),
    $3cab4107c0c47fc8$var$load("g9CVe"),
    $3cab4107c0c47fc8$var$load("aeEUI"),
    $3cab4107c0c47fc8$var$load("iXzmH"),
    $3cab4107c0c47fc8$var$load("65c4i"),
    $3cab4107c0c47fc8$var$load("6wr18"),
    $3cab4107c0c47fc8$var$load("kjZZD"),
    $3cab4107c0c47fc8$var$load("3TTZL"),
    $3cab4107c0c47fc8$var$load("37ldp"),
    $3cab4107c0c47fc8$var$load("awqCy"),
    $3cab4107c0c47fc8$var$load("kHOMt"),
    $3cab4107c0c47fc8$var$load("hhss7"),
    $3cab4107c0c47fc8$var$load("e4USi"),
    $3cab4107c0c47fc8$var$load("fqika"),
    $3cab4107c0c47fc8$var$load("dlZSj"),
    $3cab4107c0c47fc8$var$load("Wowvf"),
    $3cab4107c0c47fc8$var$load("dS0Pr"),
    $3cab4107c0c47fc8$var$load("huYla"),
    $3cab4107c0c47fc8$var$load("8bVS2"),
    $3cab4107c0c47fc8$var$load("37ZO9"),
    $3cab4107c0c47fc8$var$load("1GxVg"),
    $3cab4107c0c47fc8$var$load("lTA9n"),
    $3cab4107c0c47fc8$var$load("6EQss"),
    $3cab4107c0c47fc8$var$load("6M36W"),
    $3cab4107c0c47fc8$var$load("ffEVr"),
    $3cab4107c0c47fc8$var$load("kUbUu"),
    $3cab4107c0c47fc8$var$load("9ftJe"),
    $3cab4107c0c47fc8$var$load("hUIij"),
    $3cab4107c0c47fc8$var$load("6Up0b"),
    $3cab4107c0c47fc8$var$load("lnKog"),
    $3cab4107c0c47fc8$var$load("7Omhy"),
    $3cab4107c0c47fc8$var$load("kC80R"),
    $3cab4107c0c47fc8$var$load("7EorR"),
    $3cab4107c0c47fc8$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("fPofH", function(module, exports) {

let $b85e6e65c22b8791$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b85e6e65c22b8791$var$load("2YffH"),
    $b85e6e65c22b8791$var$load("8Kivm"),
    $b85e6e65c22b8791$var$load("cf5vC"),
    $b85e6e65c22b8791$var$load("9njyL"),
    $b85e6e65c22b8791$var$load("esA9a"),
    $b85e6e65c22b8791$var$load("iQ0Jm"),
    $b85e6e65c22b8791$var$load("coJiW"),
    $b85e6e65c22b8791$var$load("8TKWI"),
    $b85e6e65c22b8791$var$load("RXppq"),
    $b85e6e65c22b8791$var$load("h4Nf7"),
    $b85e6e65c22b8791$var$load("7f9Fz"),
    $b85e6e65c22b8791$var$load("8YSo7"),
    $b85e6e65c22b8791$var$load("fqGSw"),
    $b85e6e65c22b8791$var$load("2spqH"),
    $b85e6e65c22b8791$var$load("gWSdF"),
    $b85e6e65c22b8791$var$load("6FuHS"),
    $b85e6e65c22b8791$var$load("eyaRC"),
    $b85e6e65c22b8791$var$load("g9CVe"),
    $b85e6e65c22b8791$var$load("aeEUI"),
    $b85e6e65c22b8791$var$load("iXzmH"),
    $b85e6e65c22b8791$var$load("65c4i"),
    $b85e6e65c22b8791$var$load("6wr18"),
    $b85e6e65c22b8791$var$load("kjZZD"),
    $b85e6e65c22b8791$var$load("3TTZL"),
    $b85e6e65c22b8791$var$load("37ldp"),
    $b85e6e65c22b8791$var$load("awqCy"),
    $b85e6e65c22b8791$var$load("kHOMt"),
    $b85e6e65c22b8791$var$load("hhss7"),
    $b85e6e65c22b8791$var$load("e4USi"),
    $b85e6e65c22b8791$var$load("fqika"),
    $b85e6e65c22b8791$var$load("dlZSj"),
    $b85e6e65c22b8791$var$load("Wowvf"),
    $b85e6e65c22b8791$var$load("dS0Pr"),
    $b85e6e65c22b8791$var$load("huYla"),
    $b85e6e65c22b8791$var$load("8bVS2"),
    $b85e6e65c22b8791$var$load("37ZO9"),
    $b85e6e65c22b8791$var$load("1GxVg"),
    $b85e6e65c22b8791$var$load("lTA9n"),
    $b85e6e65c22b8791$var$load("6EQss"),
    $b85e6e65c22b8791$var$load("6M36W"),
    $b85e6e65c22b8791$var$load("ffEVr"),
    $b85e6e65c22b8791$var$load("kUbUu"),
    $b85e6e65c22b8791$var$load("9ftJe"),
    $b85e6e65c22b8791$var$load("hUIij"),
    $b85e6e65c22b8791$var$load("6Up0b"),
    $b85e6e65c22b8791$var$load("lnKog"),
    $b85e6e65c22b8791$var$load("7Omhy"),
    $b85e6e65c22b8791$var$load("kC80R"),
    $b85e6e65c22b8791$var$load("7EorR"),
    $b85e6e65c22b8791$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("dxq9B", function(module, exports) {

let $9db2a51210224a5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9db2a51210224a5c$var$load("6FuHS"),
    $9db2a51210224a5c$var$load("eyaRC"),
    $9db2a51210224a5c$var$load("2YffH"),
    $9db2a51210224a5c$var$load("cf5vC"),
    $9db2a51210224a5c$var$load("9njyL"),
    $9db2a51210224a5c$var$load("esA9a"),
    $9db2a51210224a5c$var$load("8TKWI"),
    $9db2a51210224a5c$var$load("RXppq"),
    $9db2a51210224a5c$var$load("h4Nf7"),
    $9db2a51210224a5c$var$load("7f9Fz"),
    $9db2a51210224a5c$var$load("8YSo7"),
    $9db2a51210224a5c$var$load("fqGSw"),
    $9db2a51210224a5c$var$load("2spqH"),
    $9db2a51210224a5c$var$load("gWSdF"),
    $9db2a51210224a5c$var$load("g9CVe"),
    $9db2a51210224a5c$var$load("aeEUI"),
    $9db2a51210224a5c$var$load("iXzmH"),
    $9db2a51210224a5c$var$load("65c4i"),
    $9db2a51210224a5c$var$load("6wr18"),
    $9db2a51210224a5c$var$load("kjZZD"),
    $9db2a51210224a5c$var$load("3TTZL"),
    $9db2a51210224a5c$var$load("37ldp"),
    $9db2a51210224a5c$var$load("awqCy"),
    $9db2a51210224a5c$var$load("kHOMt"),
    $9db2a51210224a5c$var$load("hhss7"),
    $9db2a51210224a5c$var$load("e4USi"),
    $9db2a51210224a5c$var$load("fqika"),
    $9db2a51210224a5c$var$load("dlZSj"),
    $9db2a51210224a5c$var$load("Wowvf"),
    $9db2a51210224a5c$var$load("dS0Pr"),
    $9db2a51210224a5c$var$load("huYla"),
    $9db2a51210224a5c$var$load("8bVS2"),
    $9db2a51210224a5c$var$load("37ZO9"),
    $9db2a51210224a5c$var$load("1GxVg"),
    $9db2a51210224a5c$var$load("lTA9n"),
    $9db2a51210224a5c$var$load("6EQss"),
    $9db2a51210224a5c$var$load("6M36W"),
    $9db2a51210224a5c$var$load("hUIij"),
    $9db2a51210224a5c$var$load("ffEVr"),
    $9db2a51210224a5c$var$load("kUbUu"),
    $9db2a51210224a5c$var$load("9ftJe"),
    $9db2a51210224a5c$var$load("7Omhy"),
    $9db2a51210224a5c$var$load("kC80R"),
    $9db2a51210224a5c$var$load("7EorR"),
    $9db2a51210224a5c$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("9ntg5", function(module, exports) {

let $6d3cf52f453a81d4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6d3cf52f453a81d4$var$load("6FuHS"),
    $6d3cf52f453a81d4$var$load("eyaRC"),
    $6d3cf52f453a81d4$var$load("2YffH"),
    $6d3cf52f453a81d4$var$load("cf5vC"),
    $6d3cf52f453a81d4$var$load("9njyL"),
    $6d3cf52f453a81d4$var$load("esA9a"),
    $6d3cf52f453a81d4$var$load("8TKWI"),
    $6d3cf52f453a81d4$var$load("RXppq"),
    $6d3cf52f453a81d4$var$load("h4Nf7"),
    $6d3cf52f453a81d4$var$load("7f9Fz"),
    $6d3cf52f453a81d4$var$load("8YSo7"),
    $6d3cf52f453a81d4$var$load("fqGSw"),
    $6d3cf52f453a81d4$var$load("2spqH"),
    $6d3cf52f453a81d4$var$load("gWSdF"),
    $6d3cf52f453a81d4$var$load("g9CVe"),
    $6d3cf52f453a81d4$var$load("aeEUI"),
    $6d3cf52f453a81d4$var$load("iXzmH"),
    $6d3cf52f453a81d4$var$load("65c4i"),
    $6d3cf52f453a81d4$var$load("6wr18"),
    $6d3cf52f453a81d4$var$load("kjZZD"),
    $6d3cf52f453a81d4$var$load("3TTZL"),
    $6d3cf52f453a81d4$var$load("37ldp"),
    $6d3cf52f453a81d4$var$load("awqCy"),
    $6d3cf52f453a81d4$var$load("kHOMt"),
    $6d3cf52f453a81d4$var$load("hhss7"),
    $6d3cf52f453a81d4$var$load("e4USi"),
    $6d3cf52f453a81d4$var$load("fqika"),
    $6d3cf52f453a81d4$var$load("dlZSj"),
    $6d3cf52f453a81d4$var$load("Wowvf"),
    $6d3cf52f453a81d4$var$load("dS0Pr"),
    $6d3cf52f453a81d4$var$load("huYla"),
    $6d3cf52f453a81d4$var$load("8bVS2"),
    $6d3cf52f453a81d4$var$load("37ZO9"),
    $6d3cf52f453a81d4$var$load("1GxVg"),
    $6d3cf52f453a81d4$var$load("lTA9n"),
    $6d3cf52f453a81d4$var$load("6EQss"),
    $6d3cf52f453a81d4$var$load("6M36W"),
    $6d3cf52f453a81d4$var$load("hUIij"),
    $6d3cf52f453a81d4$var$load("ffEVr"),
    $6d3cf52f453a81d4$var$load("kUbUu"),
    $6d3cf52f453a81d4$var$load("9ftJe"),
    $6d3cf52f453a81d4$var$load("7Omhy"),
    $6d3cf52f453a81d4$var$load("kC80R"),
    $6d3cf52f453a81d4$var$load("7EorR"),
    $6d3cf52f453a81d4$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("01OTD", function(module, exports) {

let $00016999152c04eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $00016999152c04eb$var$load("6FuHS"),
    $00016999152c04eb$var$load("eyaRC"),
    $00016999152c04eb$var$load("2YffH"),
    $00016999152c04eb$var$load("cf5vC"),
    $00016999152c04eb$var$load("9njyL"),
    $00016999152c04eb$var$load("esA9a"),
    $00016999152c04eb$var$load("8TKWI"),
    $00016999152c04eb$var$load("RXppq"),
    $00016999152c04eb$var$load("h4Nf7"),
    $00016999152c04eb$var$load("7f9Fz"),
    $00016999152c04eb$var$load("8YSo7"),
    $00016999152c04eb$var$load("fqGSw"),
    $00016999152c04eb$var$load("2spqH"),
    $00016999152c04eb$var$load("gWSdF"),
    $00016999152c04eb$var$load("g9CVe"),
    $00016999152c04eb$var$load("aeEUI"),
    $00016999152c04eb$var$load("iXzmH"),
    $00016999152c04eb$var$load("65c4i"),
    $00016999152c04eb$var$load("6wr18"),
    $00016999152c04eb$var$load("kjZZD"),
    $00016999152c04eb$var$load("3TTZL"),
    $00016999152c04eb$var$load("37ldp"),
    $00016999152c04eb$var$load("awqCy"),
    $00016999152c04eb$var$load("kHOMt"),
    $00016999152c04eb$var$load("hhss7"),
    $00016999152c04eb$var$load("e4USi"),
    $00016999152c04eb$var$load("fqika"),
    $00016999152c04eb$var$load("dlZSj"),
    $00016999152c04eb$var$load("Wowvf"),
    $00016999152c04eb$var$load("dS0Pr"),
    $00016999152c04eb$var$load("huYla"),
    $00016999152c04eb$var$load("8bVS2"),
    $00016999152c04eb$var$load("37ZO9"),
    $00016999152c04eb$var$load("1GxVg"),
    $00016999152c04eb$var$load("lTA9n"),
    $00016999152c04eb$var$load("6EQss"),
    $00016999152c04eb$var$load("6M36W"),
    $00016999152c04eb$var$load("hUIij"),
    $00016999152c04eb$var$load("ffEVr"),
    $00016999152c04eb$var$load("kUbUu"),
    $00016999152c04eb$var$load("9ftJe"),
    $00016999152c04eb$var$load("7Omhy"),
    $00016999152c04eb$var$load("kC80R"),
    $00016999152c04eb$var$load("7EorR"),
    $00016999152c04eb$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("f4Yec", function(module, exports) {

let $afa5f2c4fc309014$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afa5f2c4fc309014$var$load("6FuHS"),
    $afa5f2c4fc309014$var$load("eyaRC"),
    $afa5f2c4fc309014$var$load("2YffH"),
    $afa5f2c4fc309014$var$load("cf5vC"),
    $afa5f2c4fc309014$var$load("9njyL"),
    $afa5f2c4fc309014$var$load("esA9a"),
    $afa5f2c4fc309014$var$load("8TKWI"),
    $afa5f2c4fc309014$var$load("RXppq"),
    $afa5f2c4fc309014$var$load("h4Nf7"),
    $afa5f2c4fc309014$var$load("7f9Fz"),
    $afa5f2c4fc309014$var$load("8YSo7"),
    $afa5f2c4fc309014$var$load("fqGSw"),
    $afa5f2c4fc309014$var$load("2spqH"),
    $afa5f2c4fc309014$var$load("gWSdF"),
    $afa5f2c4fc309014$var$load("g9CVe"),
    $afa5f2c4fc309014$var$load("aeEUI"),
    $afa5f2c4fc309014$var$load("iXzmH"),
    $afa5f2c4fc309014$var$load("65c4i"),
    $afa5f2c4fc309014$var$load("6wr18"),
    $afa5f2c4fc309014$var$load("kjZZD"),
    $afa5f2c4fc309014$var$load("3TTZL"),
    $afa5f2c4fc309014$var$load("37ldp"),
    $afa5f2c4fc309014$var$load("awqCy"),
    $afa5f2c4fc309014$var$load("kHOMt"),
    $afa5f2c4fc309014$var$load("hhss7"),
    $afa5f2c4fc309014$var$load("e4USi"),
    $afa5f2c4fc309014$var$load("fqika"),
    $afa5f2c4fc309014$var$load("dlZSj"),
    $afa5f2c4fc309014$var$load("Wowvf"),
    $afa5f2c4fc309014$var$load("dS0Pr"),
    $afa5f2c4fc309014$var$load("huYla"),
    $afa5f2c4fc309014$var$load("8bVS2"),
    $afa5f2c4fc309014$var$load("37ZO9"),
    $afa5f2c4fc309014$var$load("1GxVg"),
    $afa5f2c4fc309014$var$load("lTA9n"),
    $afa5f2c4fc309014$var$load("6EQss"),
    $afa5f2c4fc309014$var$load("6M36W"),
    $afa5f2c4fc309014$var$load("ffEVr"),
    $afa5f2c4fc309014$var$load("kUbUu"),
    $afa5f2c4fc309014$var$load("9ftJe"),
    $afa5f2c4fc309014$var$load("hUIij"),
    $afa5f2c4fc309014$var$load("6Up0b"),
    $afa5f2c4fc309014$var$load("lnKog"),
    $afa5f2c4fc309014$var$load("7Omhy"),
    $afa5f2c4fc309014$var$load("kC80R"),
    $afa5f2c4fc309014$var$load("7EorR"),
    $afa5f2c4fc309014$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("1qLQm", function(module, exports) {

let $10ad54e29eeae8d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $10ad54e29eeae8d1$var$load("2YffH"),
    $10ad54e29eeae8d1$var$load("cf5vC"),
    $10ad54e29eeae8d1$var$load("9njyL"),
    $10ad54e29eeae8d1$var$load("esA9a"),
    $10ad54e29eeae8d1$var$load("coJiW"),
    $10ad54e29eeae8d1$var$load("8TKWI"),
    $10ad54e29eeae8d1$var$load("RXppq"),
    $10ad54e29eeae8d1$var$load("h4Nf7"),
    $10ad54e29eeae8d1$var$load("7f9Fz"),
    $10ad54e29eeae8d1$var$load("8YSo7"),
    $10ad54e29eeae8d1$var$load("fqGSw"),
    $10ad54e29eeae8d1$var$load("2spqH"),
    $10ad54e29eeae8d1$var$load("gWSdF"),
    $10ad54e29eeae8d1$var$load("6FuHS"),
    $10ad54e29eeae8d1$var$load("eyaRC"),
    $10ad54e29eeae8d1$var$load("g9CVe"),
    $10ad54e29eeae8d1$var$load("aeEUI"),
    $10ad54e29eeae8d1$var$load("iXzmH"),
    $10ad54e29eeae8d1$var$load("65c4i"),
    $10ad54e29eeae8d1$var$load("6wr18"),
    $10ad54e29eeae8d1$var$load("kjZZD"),
    $10ad54e29eeae8d1$var$load("3TTZL"),
    $10ad54e29eeae8d1$var$load("37ldp"),
    $10ad54e29eeae8d1$var$load("dTsOE"),
    $10ad54e29eeae8d1$var$load("awqCy"),
    $10ad54e29eeae8d1$var$load("kHOMt"),
    $10ad54e29eeae8d1$var$load("hhss7"),
    $10ad54e29eeae8d1$var$load("e4USi"),
    $10ad54e29eeae8d1$var$load("fqika"),
    $10ad54e29eeae8d1$var$load("dlZSj"),
    $10ad54e29eeae8d1$var$load("Wowvf"),
    $10ad54e29eeae8d1$var$load("dS0Pr"),
    $10ad54e29eeae8d1$var$load("huYla"),
    $10ad54e29eeae8d1$var$load("8bVS2"),
    $10ad54e29eeae8d1$var$load("37ZO9"),
    $10ad54e29eeae8d1$var$load("1GxVg"),
    $10ad54e29eeae8d1$var$load("lTA9n"),
    $10ad54e29eeae8d1$var$load("6EQss"),
    $10ad54e29eeae8d1$var$load("6M36W"),
    $10ad54e29eeae8d1$var$load("ffEVr"),
    $10ad54e29eeae8d1$var$load("kUbUu"),
    $10ad54e29eeae8d1$var$load("9ftJe"),
    $10ad54e29eeae8d1$var$load("hUIij"),
    $10ad54e29eeae8d1$var$load("6Up0b"),
    $10ad54e29eeae8d1$var$load("lnKog"),
    $10ad54e29eeae8d1$var$load("7Omhy"),
    $10ad54e29eeae8d1$var$load("kC80R"),
    $10ad54e29eeae8d1$var$load("7EorR"),
    $10ad54e29eeae8d1$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("hiGFp", function(module, exports) {

let $c98536e15fc16739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c98536e15fc16739$var$load("2YffH"),
    $c98536e15fc16739$var$load("cf5vC"),
    $c98536e15fc16739$var$load("9njyL"),
    $c98536e15fc16739$var$load("esA9a"),
    $c98536e15fc16739$var$load("coJiW"),
    $c98536e15fc16739$var$load("8TKWI"),
    $c98536e15fc16739$var$load("RXppq"),
    $c98536e15fc16739$var$load("h4Nf7"),
    $c98536e15fc16739$var$load("7f9Fz"),
    $c98536e15fc16739$var$load("8YSo7"),
    $c98536e15fc16739$var$load("fqGSw"),
    $c98536e15fc16739$var$load("2spqH"),
    $c98536e15fc16739$var$load("gWSdF"),
    $c98536e15fc16739$var$load("6FuHS"),
    $c98536e15fc16739$var$load("eyaRC"),
    $c98536e15fc16739$var$load("g9CVe"),
    $c98536e15fc16739$var$load("aeEUI"),
    $c98536e15fc16739$var$load("iXzmH"),
    $c98536e15fc16739$var$load("65c4i"),
    $c98536e15fc16739$var$load("6wr18"),
    $c98536e15fc16739$var$load("kjZZD"),
    $c98536e15fc16739$var$load("3TTZL"),
    $c98536e15fc16739$var$load("37ldp"),
    $c98536e15fc16739$var$load("dTsOE"),
    $c98536e15fc16739$var$load("awqCy"),
    $c98536e15fc16739$var$load("kHOMt"),
    $c98536e15fc16739$var$load("hhss7"),
    $c98536e15fc16739$var$load("e4USi"),
    $c98536e15fc16739$var$load("fqika"),
    $c98536e15fc16739$var$load("dlZSj"),
    $c98536e15fc16739$var$load("Wowvf"),
    $c98536e15fc16739$var$load("dS0Pr"),
    $c98536e15fc16739$var$load("huYla"),
    $c98536e15fc16739$var$load("8bVS2"),
    $c98536e15fc16739$var$load("37ZO9"),
    $c98536e15fc16739$var$load("1GxVg"),
    $c98536e15fc16739$var$load("lTA9n"),
    $c98536e15fc16739$var$load("6EQss"),
    $c98536e15fc16739$var$load("6M36W"),
    $c98536e15fc16739$var$load("ffEVr"),
    $c98536e15fc16739$var$load("kUbUu"),
    $c98536e15fc16739$var$load("9ftJe"),
    $c98536e15fc16739$var$load("hUIij"),
    $c98536e15fc16739$var$load("6Up0b"),
    $c98536e15fc16739$var$load("lnKog"),
    $c98536e15fc16739$var$load("7Omhy"),
    $c98536e15fc16739$var$load("kC80R"),
    $c98536e15fc16739$var$load("7EorR"),
    $c98536e15fc16739$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6gEsG", function(module, exports) {

let $49039f86ff7e86b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49039f86ff7e86b5$var$load("6FuHS"),
    $49039f86ff7e86b5$var$load("eyaRC"),
    $49039f86ff7e86b5$var$load("2YffH"),
    $49039f86ff7e86b5$var$load("cf5vC"),
    $49039f86ff7e86b5$var$load("9njyL"),
    $49039f86ff7e86b5$var$load("esA9a"),
    $49039f86ff7e86b5$var$load("8TKWI"),
    $49039f86ff7e86b5$var$load("RXppq"),
    $49039f86ff7e86b5$var$load("h4Nf7"),
    $49039f86ff7e86b5$var$load("7f9Fz"),
    $49039f86ff7e86b5$var$load("8YSo7"),
    $49039f86ff7e86b5$var$load("fqGSw"),
    $49039f86ff7e86b5$var$load("2spqH"),
    $49039f86ff7e86b5$var$load("gWSdF"),
    $49039f86ff7e86b5$var$load("g9CVe"),
    $49039f86ff7e86b5$var$load("aeEUI"),
    $49039f86ff7e86b5$var$load("iXzmH"),
    $49039f86ff7e86b5$var$load("65c4i"),
    $49039f86ff7e86b5$var$load("6wr18"),
    $49039f86ff7e86b5$var$load("kjZZD"),
    $49039f86ff7e86b5$var$load("3TTZL"),
    $49039f86ff7e86b5$var$load("37ldp"),
    $49039f86ff7e86b5$var$load("awqCy"),
    $49039f86ff7e86b5$var$load("kHOMt"),
    $49039f86ff7e86b5$var$load("hhss7"),
    $49039f86ff7e86b5$var$load("e4USi"),
    $49039f86ff7e86b5$var$load("fqika"),
    $49039f86ff7e86b5$var$load("dlZSj"),
    $49039f86ff7e86b5$var$load("Wowvf"),
    $49039f86ff7e86b5$var$load("dS0Pr"),
    $49039f86ff7e86b5$var$load("huYla"),
    $49039f86ff7e86b5$var$load("8bVS2"),
    $49039f86ff7e86b5$var$load("37ZO9"),
    $49039f86ff7e86b5$var$load("1GxVg"),
    $49039f86ff7e86b5$var$load("lTA9n"),
    $49039f86ff7e86b5$var$load("6EQss"),
    $49039f86ff7e86b5$var$load("6M36W"),
    $49039f86ff7e86b5$var$load("hUIij"),
    $49039f86ff7e86b5$var$load("ffEVr"),
    $49039f86ff7e86b5$var$load("kUbUu"),
    $49039f86ff7e86b5$var$load("9ftJe"),
    $49039f86ff7e86b5$var$load("7Omhy"),
    $49039f86ff7e86b5$var$load("kC80R"),
    $49039f86ff7e86b5$var$load("7EorR"),
    $49039f86ff7e86b5$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("jP195", function(module, exports) {

let $e6e3ab339aa05f2e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6e3ab339aa05f2e$var$load("6FuHS"),
    $e6e3ab339aa05f2e$var$load("eyaRC"),
    $e6e3ab339aa05f2e$var$load("2YffH"),
    $e6e3ab339aa05f2e$var$load("cf5vC"),
    $e6e3ab339aa05f2e$var$load("9njyL"),
    $e6e3ab339aa05f2e$var$load("esA9a"),
    $e6e3ab339aa05f2e$var$load("8TKWI"),
    $e6e3ab339aa05f2e$var$load("RXppq"),
    $e6e3ab339aa05f2e$var$load("h4Nf7"),
    $e6e3ab339aa05f2e$var$load("7f9Fz"),
    $e6e3ab339aa05f2e$var$load("8YSo7"),
    $e6e3ab339aa05f2e$var$load("fqGSw"),
    $e6e3ab339aa05f2e$var$load("2spqH"),
    $e6e3ab339aa05f2e$var$load("gWSdF"),
    $e6e3ab339aa05f2e$var$load("g9CVe"),
    $e6e3ab339aa05f2e$var$load("aeEUI"),
    $e6e3ab339aa05f2e$var$load("iXzmH"),
    $e6e3ab339aa05f2e$var$load("65c4i"),
    $e6e3ab339aa05f2e$var$load("6wr18"),
    $e6e3ab339aa05f2e$var$load("kjZZD"),
    $e6e3ab339aa05f2e$var$load("3TTZL"),
    $e6e3ab339aa05f2e$var$load("37ldp"),
    $e6e3ab339aa05f2e$var$load("awqCy"),
    $e6e3ab339aa05f2e$var$load("kHOMt"),
    $e6e3ab339aa05f2e$var$load("hhss7"),
    $e6e3ab339aa05f2e$var$load("e4USi"),
    $e6e3ab339aa05f2e$var$load("fqika"),
    $e6e3ab339aa05f2e$var$load("dlZSj"),
    $e6e3ab339aa05f2e$var$load("Wowvf"),
    $e6e3ab339aa05f2e$var$load("dS0Pr"),
    $e6e3ab339aa05f2e$var$load("huYla"),
    $e6e3ab339aa05f2e$var$load("8bVS2"),
    $e6e3ab339aa05f2e$var$load("37ZO9"),
    $e6e3ab339aa05f2e$var$load("1GxVg"),
    $e6e3ab339aa05f2e$var$load("lTA9n"),
    $e6e3ab339aa05f2e$var$load("6EQss"),
    $e6e3ab339aa05f2e$var$load("6M36W"),
    $e6e3ab339aa05f2e$var$load("ffEVr"),
    $e6e3ab339aa05f2e$var$load("kUbUu"),
    $e6e3ab339aa05f2e$var$load("9ftJe"),
    $e6e3ab339aa05f2e$var$load("hUIij"),
    $e6e3ab339aa05f2e$var$load("6Up0b"),
    $e6e3ab339aa05f2e$var$load("lnKog"),
    $e6e3ab339aa05f2e$var$load("7Omhy"),
    $e6e3ab339aa05f2e$var$load("kC80R"),
    $e6e3ab339aa05f2e$var$load("7EorR"),
    $e6e3ab339aa05f2e$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("2K4NM", function(module, exports) {

let $1ff39a33d474090e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ff39a33d474090e$var$load("6FuHS"),
    $1ff39a33d474090e$var$load("eyaRC"),
    $1ff39a33d474090e$var$load("2YffH"),
    $1ff39a33d474090e$var$load("cf5vC"),
    $1ff39a33d474090e$var$load("9njyL"),
    $1ff39a33d474090e$var$load("esA9a"),
    $1ff39a33d474090e$var$load("8TKWI"),
    $1ff39a33d474090e$var$load("RXppq"),
    $1ff39a33d474090e$var$load("h4Nf7"),
    $1ff39a33d474090e$var$load("7f9Fz"),
    $1ff39a33d474090e$var$load("8YSo7"),
    $1ff39a33d474090e$var$load("fqGSw"),
    $1ff39a33d474090e$var$load("2spqH"),
    $1ff39a33d474090e$var$load("gWSdF"),
    $1ff39a33d474090e$var$load("g9CVe"),
    $1ff39a33d474090e$var$load("aeEUI"),
    $1ff39a33d474090e$var$load("iXzmH"),
    $1ff39a33d474090e$var$load("65c4i"),
    $1ff39a33d474090e$var$load("6wr18"),
    $1ff39a33d474090e$var$load("kjZZD"),
    $1ff39a33d474090e$var$load("3TTZL"),
    $1ff39a33d474090e$var$load("37ldp"),
    $1ff39a33d474090e$var$load("awqCy"),
    $1ff39a33d474090e$var$load("kHOMt"),
    $1ff39a33d474090e$var$load("hhss7"),
    $1ff39a33d474090e$var$load("e4USi"),
    $1ff39a33d474090e$var$load("fqika"),
    $1ff39a33d474090e$var$load("dlZSj"),
    $1ff39a33d474090e$var$load("Wowvf"),
    $1ff39a33d474090e$var$load("dS0Pr"),
    $1ff39a33d474090e$var$load("huYla"),
    $1ff39a33d474090e$var$load("8bVS2"),
    $1ff39a33d474090e$var$load("37ZO9"),
    $1ff39a33d474090e$var$load("1GxVg"),
    $1ff39a33d474090e$var$load("lTA9n"),
    $1ff39a33d474090e$var$load("6EQss"),
    $1ff39a33d474090e$var$load("6M36W"),
    $1ff39a33d474090e$var$load("ffEVr"),
    $1ff39a33d474090e$var$load("kUbUu"),
    $1ff39a33d474090e$var$load("9ftJe"),
    $1ff39a33d474090e$var$load("hUIij"),
    $1ff39a33d474090e$var$load("6Up0b"),
    $1ff39a33d474090e$var$load("lnKog"),
    $1ff39a33d474090e$var$load("7Omhy"),
    $1ff39a33d474090e$var$load("kC80R"),
    $1ff39a33d474090e$var$load("7EorR"),
    $1ff39a33d474090e$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.82e41037.js.map
